import React from 'react';
import { TabList as HeadlessTabList } from '@headlessui/react';
import { cn } from '../../utils/cn';

export const TabList = React.forwardRef<
  React.ElementRef<typeof HeadlessTabList>,
  React.ComponentPropsWithoutRef<typeof HeadlessTabList> & {
    className?: string;
  }
>(({ children, className, ...props }, ref) => (
  <HeadlessTabList
    ref={ref}
    className={cn(
      // Layout
      'flex',

      // Spacing and alignment
      'gap-0.5',

      // Background and border
      'border-tabs-border bg-background-tabs',

      className,
    )}
    {...props}
  >
    {children}
  </HeadlessTabList>
));

TabList.displayName = 'TabList';
